import { RegularButton } from 'pg-ui-library';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  background-color: #fff;
`;

export const StepsContainer = styled.div`
  display: flex;
  background-color: #fff;
  padding: 30px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    height: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f3f4f8 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: #222247 0% 0% no-repeat padding-box;
    border-radius: 4px;
    opacity: 1;
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
`;

interface StepsContainerProps {
  active: boolean;
  available: boolean;
}
export const StepsTextContainer = styled.div<StepsContainerProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 10px;
  font-weight: 600;
  cursor: ${props => props.available && 'pointer'};
  color: ${props => props.active && '#4948AC'};
  color: ${props => (props.available ? props.active && '#4948AC' : '#C9CBD3')};
  font-size: 18px;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex: 1;
  padding-right: 20px;
  padding-left: 20px;
`;

export const HorizontalLine = styled.div`
  width: 40px;
  height: 1px;
  background-color: #c9cbd3; // You can change the color as needed
`;

export const FooterContainer = styled.div`
  width: 100%;
  display: flex;

  justify-content: space-between;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 20px #00000029;
`;

export const FooterItemLeft = styled.div`
  display: flex;
  align-items: center;
  column-gap: 15px;
`;

export const ArrowBack = styled.img`
  height: 25px;
  width: auto;
`;

export const BackText = styled.div`
  font-size: 18px;
`;

export const NextButton = styled(RegularButton)`
  max-height: 50px;
  margin: 0;
  height: 50px;
  width: 150px;
  border-radius: 0;
  text-wrap: wrap;
`;

export const BackButton = styled.button`
  background-color: #fff;
  border: none;
`;

export const BackButtonItems = styled.button`
  display: flex;
  align-items: center;
  padding-left: 30px;
  gap: 10px;
  cursor: pointer;
  background-color: #fff;
  border: none;
`;
